<template>
  <div class="topbar-left" @mouseover="hover = true" @mouseleave="hover = false">
    <div class="hidden-md-up">
      <div class="logo" style="cursor: pointer;" @click="toggleMenu">
        <i class="zmdi zmdi-menu"></i>
        <span>App</span>
      </div>
    </div>
    <div class="hidden-sm-down" :style="{backgroundColor: keystone.config.app.color}">
      <router-link to="/" class="logo">
        <i :class="keystone.config.app.icon + ' icon-c-logo'"></i>
        <span>App</span>
      </router-link>
    </div>
    <transition name="fade">
      <ul class="selection" v-if="hover">
        <li v-for="app in keystone.config.app.interfaces" :key="app.to" :style="{backgroundColor: app.color}"
            @click="goToBilling(app.to)">
          <i :class="app.icon"></i>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
  let $ = window.$

  export default {
    name: 'logo',
    data () {
      return {
        hover: false
      }
    },
    methods: {
      toggleMenu () {
        $('.left.side-menu').toggleClass('displayed')
      },
      goToBilling (name) {
        let parser = document.createElement('a')
        parser.href = document.location.href
        if (parser.hash.startsWith('#/reminders') || parser.hash.startsWith('#/customers')) {
          document.location.href = name + parser.hash
        } else {
          document.location.href = name
        }
      }
    }
  }
</script>

<style scoped>
  .logo, .selection a i {
    color: white !important;
  }

  ul.selection {
    padding: 0;
    position: absolute;
    top: 0;
    list-style-type: none;
    left: 100%;
    white-space: nowrap;
    font-size: 0;
  }

  ul.selection li {
    width: 70px;
    height: 70px;
    color: white;
    display: inline-block;
    cursor: pointer;
  }

  ul.selection li i {
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-right: 0px;
    line-height: 70px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// Logo.vue?00dba129